import React from 'react';
import { render } from '@testing-library/react';
import { FilterButton } from './FilterButton';

describe('FilterButton', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<FilterButton label="Active" data-auto-sel="automation-selector" />
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
